app.service('instalmentOrderAction', function (console, modal, loading, orderConfig) {
	var $self;
	var config;

	function open() {
		modal.open('instalment-orders-requiring-actions');
	}
	function goToSetDeliveryTime(orderNumber) {
		loading.start();
		document.location.href = '/customer-order-preview.bhtml?orderNumber=' + orderNumber + '#ustalTermin';
	}
	function setElements() {
		$self = $('#modal-instalment-orders-requiring-actions');
		config = orderConfig.getData();
	}
	function setEvents(closeCallback) {
		$('.js-to-set-delivery-time', $self).on('click', function () {
			goToSetDeliveryTime($(this).data('order'));
		});
		if (closeCallback) {
			$(document).on('closing', $self, function () {
				closeCallback();
			});
		}
	}
	function init(closeCallback) {
		setElements();
		setEvents(closeCallback);

		if (config.instalmentOrdersRequiringActions && !config.instalmentOrdersRequiringNext) {
			setTimeout(function () {
				open();
			}, 1000);
		}
	}
	return {
		init,
		open
	};
});
